import { Link } from 'react-router-dom';

export default function PlansOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="text-lg">🍑</span>
            <p className="text-xs font-semibold tracking-widest text-pink-400 uppercase">Pricing Plans</p>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-800 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            お客様に合わせた料金プラン
          </h2>
          <p className="text-gray-500 text-sm md:text-base">中小企業様・個人事業主様それぞれに最適なプランをご用意</p>
        </div>

        {/* Plan Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Personal Plan */}
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 border border-pink-100 rounded-2xl p-8">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-lg">🍑</span>
              <span className="text-xs font-semibold text-pink-500 tracking-wider uppercase">Personal</span>
            </div>
            <h3 className="text-gray-800 font-bold text-xl mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              個人事業主様向けプラン
            </h3>
            <p className="text-4xl font-black text-gray-800 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¥50,000<span className="text-base font-normal text-gray-500">〜</span>
            </p>
            <ul className="flex flex-col gap-2 mb-8">
              {['小規模Webサイト制作', '簡易アプリ開発', 'SNS広告運用サポート', 'メール・チャットサポート'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-pink-400"></i>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/plans"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white border border-pink-300 text-pink-500 font-semibold px-6 py-2.5 rounded-full hover:bg-pink-50 transition-colors text-sm"
            >
              詳しく見る <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* SME Plan */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100 rounded-2xl p-8">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-lg">🏢</span>
              <span className="text-xs font-semibold text-emerald-600 tracking-wider uppercase">Business</span>
            </div>
            <h3 className="text-gray-800 font-bold text-xl mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              中小企業様向けプラン
            </h3>
            <p className="text-4xl font-black text-gray-800 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¥200,000<span className="text-base font-normal text-gray-500">〜</span>
            </p>
            <ul className="flex flex-col gap-2 mb-8">
              {['業務システム開発', '本格的なアプリ制作', '広告運用・分析レポート', '保守・運用サポート', '専任担当者によるサポート'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-500"></i>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/plans"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white border border-emerald-300 text-emerald-600 font-semibold px-6 py-2.5 rounded-full hover:bg-emerald-50 transition-colors text-sm"
            >
              詳しく見る <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Custom Plan Banner */}
        <div className="bg-gradient-to-r from-pink-400 via-rose-400 to-emerald-400 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-xl mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              完全カスタムプラン
            </h3>
            <p className="text-white/80 text-sm">
              お客様のご要望に応じて柔軟に対応いたします。まずはお気軽にご相談ください。
            </p>
          </div>
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer bg-white text-gray-800 font-semibold px-7 py-3 rounded-full hover:bg-gray-50 transition-colors text-sm flex items-center gap-2"
          >
            <i className="ri-mail-line"></i>
            お問い合わせ
          </Link>
        </div>
      </div>
    </section>
  );
}
